import { Color, Line, Line2, LineGeometry, LineMaterial, Mesh, Vector2, Vector3 } from '@anov/3d-core'

import type * as THREE from '@anov/3d-core'
import type { FillAreaOption } from '../type'
import { RoundLineGeometry, createRoundedClosedCurve } from '../../Utils/round-curve'
import FillAreaBase from './FillAreaBase'

interface Point {
  x: number
  y: number
  z: number
}
class FillArea_Line_01 extends FillAreaBase {
  constructor(option: FillAreaOption, areaInstance: THREE.Object3D) {
    super(option, areaInstance)
    this.create()
  }

  create() {
    this._mesh = this.createMesh(this._points, this._color, this._alpha)
    this._mesh && this.add(this._mesh)
  }

  createMesh(points: Vector3[], color: string, alpha: number) {
    if (!points)
      return
    // 创建材质，这里设置为线的材质，比如LineMaterial
    const material = new LineMaterial({
      color: new Color(color).getHex(),
      transparent: true,
      opacity: alpha,
      // blending: THREE.NormalBlending, // 启用混合模式以使透明度生效
      depthTest: false,
      alphaTest: 0.01,
      linewidth: 15,
      resolution: new Vector2(window.innerWidth, window.innerHeight),
    })
    // const roundLineGeometry = new RoundLineGeometry(points, { radius: this._corner, close: this._close })
    // const curve = roundLineGeometry.curve
    // const currentPoints = curve.getPoints(1000)
    // // 将点转换为二维坐标（只保留x和y）
    // const points3D = currentPoints.map((p: Point) => new Vector3(p.x, 0, p.z))
    // const geometry = new LineGeometry()
    // geometry.setPositions(points3D.flatMap((p: Point) => [p.x, 0, p.z])) // 将二维坐标转换为一维数组
    // // 创建一个线的网格物体（区别于原来的面的网格物体）
    // const mesh = new Line2(geometry, material)

    const curvePath = createRoundedClosedCurve(points, this._corner, this._close)
    const pathPoints = curvePath.getPoints(1000)
    // const geometry = new THREE.BufferGeometry().setFromPoints(pathPoints)
    // const mesh = new Line2(geometry, material)
    // 将点转换为二维坐标（只保留x和y）
    const points3D = pathPoints.map((p: Point) => new Vector3(p.x, 0, p.z))
    const geometry = new LineGeometry()
    geometry.setPositions(points3D.flatMap((p: Point) => [p.x, 0, p.z])) // 将二维坐标转换为一维数组
    // 创建一个线的网格物体（区别于原来的面的网格物体）
    const mesh = new Line2(geometry, material)
    return mesh
  }

  // Getter and Setter for fenceColor property
  // get color(): string {
  //   return this._color
  // }

  // set color(newValue: string) {
  //   if (this._color === newValue)
  //     return

  //   this._color = newValue
  //   if (this.mesh)
  //     this.mesh.material.color = new Color(newValue)
  // }

  // Getter and Setter for fenceAlpha property
  // get alpha(): number {
  //   return this._alpha
  // }

  // set alpha(newValue: number) {
  //   if (this._alpha === newValue)
  //     return

  //   this._alpha = newValue
  //   if (this.mesh)
  //     this.mesh.material.opacity = newValue
  // }
}

export default FillArea_Line_01